
const Finance = {
    fetchWithdrawFee(params) {
        return axios.post(window.fetchWithdrawFeeUrl, params);
    },
    buyAirtime(params) {
        return axios.post(window.buyAirtimeUrl, params);
    },
    updateCompensation(params) {
        return axios.post(window.agencyCompensationUpdate, params);
    },
    completeCompensation(params) {
        return axios.post(window.agencyCompensationComplete, params);
    }
};

export { Finance };


// WEBPACK FOOTER //
// ./resources/assets/js/services/Finance.js